/**
 * Text filter fields for the Drops advanced panel.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { Input } from '@/components/ui';

interface FieldProps {
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
}

function FilterField({ label, placeholder, value, onChange }: FieldProps) {
  return (
    <label className="flex flex-col gap-1.5">
      <span className="text-xs font-medium text-muted-foreground">{label}</span>
      <Input
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-9"
      />
    </label>
  );
}

interface DropsFilterFieldGridProps {
  campaign: string;
  onCampaignChange: (value: string) => void;
  leadsList: string;
  onLeadsListChange: (value: string) => void;
  sender: string;
  onSenderChange: (value: string) => void;
  country: string;
  onCountryChange: (value: string) => void;
}

export const DropsFilterFieldGrid: FC<DropsFilterFieldGridProps> = (props) => (
  <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
    <FilterField
      label="Campaign"
      placeholder="e.g. AU_CASINO_MAINFLOW"
      value={props.campaign}
      onChange={props.onCampaignChange}
    />
    <FilterField
      label="Leads list"
      placeholder="e.g. AU_GG_02.12_dubs_8k"
      value={props.leadsList}
      onChange={props.onLeadsListChange}
    />
    <FilterField
      label="Sender"
      placeholder="e.g. SpinGuard"
      value={props.sender}
      onChange={props.onSenderChange}
    />
    <FilterField
      label="Country"
      placeholder="e.g. Australia"
      value={props.country}
      onChange={props.onCountryChange}
    />
  </div>
);

export default DropsFilterFieldGrid;
